// `evidence/source` — the content-safety denylist read, carved from
// `src/hooks/query/useBlockedDomains.ts` (now a pure re-export delegate).
//
// THE SIBLING THE CHAT-INVERSION SLICE NAMED AND DID NOT TAKE. That slice
// carved `useQuerySources` on a program-owner ruling and wrote, in the file it
// carved, that the same ruling reaches this one: identical shape (`GET
// /chat/blocked-domains`, identity `chat_blocked_domains`), identical consumer
// set (all five are `src/components/library/source-lists/**`, the evidence
// source pickers, none of them chat's). The only thing that kept it out was
// SCOPE — that slice was the file with a chat coupling to invert, and the
// blocklist has none. So this is a plain move with nothing new decided in it,
// which is exactly what the family record's heal said it would be.
//
// The route and the identity BOTH keep their `chat` spelling — see
// `contracts/queryKeys.ts`. The prefix records where the route lives, not who
// owns the read, and re-minting either is a cold start for every source picker.
//
// S1: transport through the `@heidi/api/client` registry (`data/api/sources.ts`)
// rather than the `@/utils/scribeHTTP` module singleton — the same instance with
// the same interceptors, so the request is byte-identical.
//
// S-enabled: THERE IS NO GATE, and the absence is the behaviour rather than an
// omission. The pre-move hook passed no `enabled`, read no token and consulted
// no flag: the denylist is user-independent, so it fetches on first mount of any
// source picker and every caller shares one cache entry. That is why its old
// path could dissolve to a re-export where four of this family's reads kept a
// body.
import { useQuery } from '@tanstack/react-query';

import { GET_BLOCKED_DOMAINS } from '../../contracts';
import { getBlockedDomains } from '../api/sources';

/**
 * Fetches the content-safety denied domains from `GET /chat/blocked-domains`.
 *
 * Used by the Library source pickers to reject blocked domains inline (the
 * server re-checks and is the source of truth — this is a UX convenience).
 * The list is near-static, so it is cached aggressively.
 */
export function useBlockedDomains() {
  return useQuery<string[]>({
    queryKey: [GET_BLOCKED_DOMAINS],
    queryFn: getBlockedDomains,
    staleTime: 60 * 60 * 1000,
  });
}
